import React, { useState } from "react";
import "./AgentRules.scss";

const AgentFilters = () => {
  const allRules = [
    { id: "recipient_account_analysis", name: "Recipient Account Analysis" },
    { id: "cross_channel_analysis", name: "Cross-Channel Analysis" },
    {
      id: "transaction_amount_thresholds",
      name: "Transaction Amount Thresholds",
    },
    { id: "account_age_monitoring", name: "Account Age Monitoring" },
  ];

  const [rules, setRules] = useState([
    { id: "account_age_monitoring", name: "Account Age Monitoring" },
  ]);
  const [selectedRuleId, setSelectedRuleId] = useState("");

  const handleAddRule = () => {
    const ruleToAdd = allRules.find((rule) => rule.id === selectedRuleId);
    if (ruleToAdd && !rules.find((rule) => rule.id === ruleToAdd.id)) {
      setRules([...rules, ruleToAdd]);
    }
  };

  const handleDeleteRule = (ruleId) => {
    setRules(rules.filter((rule) => rule.id !== ruleId));
  };

  const availableOptions = allRules.filter(
    (option) => !rules.find((rule) => rule.id === option.id)
  );

  return (
    <div className="agent-rules-container">
      <div>
        <div>
          <label for="time" class="selector-titles">
            Rule
          </label>
        </div>
        <div class="transaction-selector">
          <select
            value={selectedRuleId}
            onChange={(e) => setSelectedRuleId(e.target.value)}
          >
            <option value="">Select a rule</option>
            {availableOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <button onClick={handleAddRule}>Add Rule</button>
        </div>
      </div>
      <table className="full-width-table-rules">
        <thead>
          <tr className="header-row">
            <th>Rule</th>
            <th className="table-date-header">Status</th>
            <th className="table-date-header"> Action</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((rule) => (
            <tr key={rule.id}>
              <td>{rule.name}</td>
              <td>
                <p className="enabled-rule">Enabled</p>
              </td>
              <td>
                <button onClick={() => handleDeleteRule(rule.id)}>
                  DELETE
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AgentFilters;
